<template>
    <div>
        <breadcrumb :routerList="[{to:'/establish/rebate',title:'合同签订'},{title:'返利合同详情'}]"/>
        <div class="h-piece" style="margin:20px">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>经销商签订合同</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="ht" ref="ht" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="合同名称" class="h-elformWrap-2" prop="contractBaseId">
                                <el-input v-model="ht.contractName" :v="ht.contractName" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="经销商名称" class="h-elformWrap-2">
                                <el-input v-model="ht.agentName" :v="ht.agentName" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="ht.organization"  style="width:3.2rem" readonly>
                                </el-input>
                            </el-form-item>
                            <el-form-item  label="销售区域" class="h-elformWrap-2">
                                <el-input :v="ht.area" v-model="ht.area" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="渠道" class="h-elformWrap-2">
                                <el-input :v="ht.channel" v-model="ht.channel" style="width:3.2rem" readonly></el-input>
                            </el-form-item>
                            <br>
                            <el-form-item
                                    prop="year"
                                    label="合同有效期"
                                    class="fltimeselect">
                                <el-date-picker
                                        v-model="ht.year"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期" readonly>
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
                <div class="h-pieceTitle2 message">
                    <h1 class="h1">目标</h1>
                </div>
                <el-table
                        ref="multipleTable"
                        :data="goalList"
                        stripe
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="type"
                            label="类型"
                            :show-overflow-tooltip="true"
                    >
                        <template scope="scope">
                            <el-select v-model="scope.row.type" placeholder="请选择">
                                <el-option label="月度" value="1">月度</el-option>
                                <el-option label="季度" value="2">季度</el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="month"
                            label="月度/季度"
                    >
                        <template scope="scope">
                            <el-input v-model="scope.row.month" placeholder="请输入"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="goal"
                            :show-overflow-tooltip="true"
                            label="目标"
                    >
                        <template scope="scope">
                            <el-input v-model="scope.row.goal" placeholder="请输入"
                                      oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="rebateCoefficient"
                            :show-overflow-tooltip="true"
                            label="返利率(%)"
                    >
                        <template scope="scope">
                            <el-input v-model="scope.row.rebateCoefficient" placeholder="请输入"
                                      oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="anniu">
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgblueQ2 " @click="cancelHT">返回</el-button>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'

    export default {
        data() {
            return {
                //合同名称
                HTName: [],
                //经销商名称
                AgentName: [],
                //表单
                ht: {
                    //有效期
                    year: [],
                },
                f: {},
                //产品list
                goalList: [],
            }
        },
        mounted() {
            this.query();
        },
        created() {
            this.query();
        },
        methods: {
            query() {
                this.ht.id = this.$route.query.id;
                ss.fanli.selectfanliXiangqing(this.ht.id).then(rd => {
                    this.ht = rd;
                    this.getOrgName(rd.contractBaseId);
                    this.goalList = rd.goalList;
                    this.ht.year=[];
                    this.ht.year.push(rd.contractStartTime);
                    this.ht.year.push(rd.contractEndTime);
                });
            },
            //经销商名称带出其他信息
            showForm(value) {
                this.AgentName.forEach(elements => {
                    this.ht.agentCode = elements.userCode;
                });
            },
            //展示经销商名称
            showFormList(value) {
                this.f.userName = value;
                ss.UserCare.agentOption(this.f).then(rd => {
                    this.AgentName = rd;
                });
            },
            //通过合同名称带出销售组织
            getOrgName(value) {
                this.HTName.forEach(elements => {
                    if (value == elements.id) {
                        this.ht.contractName = elements.contractName;
                        this.ht.orgCode = this.$getDictName('kkber_value', elements.orgCode);
                        console.log("222222222222222222")
                    }
                });
            },
            //展示合同名称
            showHtName() {
                ss.fanli.showHtName().then(rd => {
                    this.HTName = rd;
                })
            },
            //取消提交
            cancelHT() {
                this.$router.push("/establish/fanliJisuanSap");
            },
        }
    }
</script>
<style scoped>
    .h-tableInput .el-input {
        height: 100%;
    }

    .anniu {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }

</style>
<style>
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.8rem
    }

    .n-two .h-formbLine .el-form-item__label {
        width: 40%;
    }

    .n-two .h-formbLine .el-form-item__content {
        width: 60%;
    }

    .create .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .create .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .fltimeselect .el-date-editor.el-input__inner {
        width: 4rem;
    }

    .fltimeselect .el-form-item__content {
        line-height: 0.2rem;
    }

    .fltimeselect .el-date-editor .el-range-separator {
        width: 12%;
        line-height: 17px;
    }

    .fltimeselect .el-input__inner {
        padding-right: 0.1rem;
    }
</style>
